import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';

import ShoppingHistoryList from './list/ShoppingHistoryList';

class ShoppingHistory extends Component {
  state = {}

  handleOnRowClick = (data) => {
    this.props.history.replace({
      pathname: `/cuenta/historial-compra/${data.id}/info`,
      state: {
        data: {...data}
      }
    });
  }

  render() {
    return (
      <div>
        <Row className="mb-3">
          <Col className="text-right">
            <h5 className="pt-2">
              Mi consumo
            </h5>
          </Col>
        </Row>

        <ShoppingHistoryList
          onRowClick={ this.handleOnRowClick }
        />

      </div>
    )
  }
}

export default ShoppingHistory;